import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { TaskService } from 'src/app/services/task.service';
import Popup from 'devextreme/ui/popup';
import DataSource from 'devextreme/data/data_source';

@Component({
  selector: 'app-memorized-task',
  templateUrl: './memorized-task.component.html',
  styleUrls: ['./memorized-task.component.scss']
})
export class MemorizedTaskComponent implements OnInit {

  @Input() projectid: any;

  popupNewSummaryMemorize: boolean = false;
  formSummaryMemorize: FormGroup;
  cancelButtonSummaryMemorize: any;
  saveButtonSummaryMemorize: any;

  popupNewTaskMemorize: boolean = false;
  formTaskMemorize: FormGroup;
  cancelButtonMemorizeTasK: any;
  saveButtonMemorizeTasK: any;

  cancelButtonImportMemorizeTasK: any;
  saveButtonImportMemorizeTasK:any;
  disableImport: boolean = true;
  rowSelectedMemorizeTasks: any = [];
  salesCategorySelect: any = [];
  popupMemorizedTask: boolean = false;
  dataSummaryMemorizeTask: any = [];
  dataMemorizeTask: any = [];

  prioritySelect: any;
  employeeSelect: any;
  categorySelect: any;
  categoriesMemorize: any;

  constructor(
    private toast: ToastService,
    private taskService: TaskService, 
  ) {

    

  }

  ngOnInit() {
    this.cancelButtonMemorizeTasK = {
      text: 'Cancel',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.popupNewTaskMemorize = false;
      },
    };

    this.saveButtonMemorizeTasK = {
      text: 'Save',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.saveUpdateMemorizeTask();
      },
    };

    this.cancelButtonSummaryMemorize = {
      text: 'Cancel',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.popupNewSummaryMemorize = false;
      },
    };

    this.saveButtonSummaryMemorize = {
      text: 'Save',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.saveUpdateSummaryMemorize();
      },
    };

    this.taskService.GetTaskCategories().subscribe(result => {
      this.categorySelect = result;
    });

    this.taskService.GetTaskEmployees().subscribe(result => {
      this.employeeSelect = result;
    });
    
    this.taskService.GetTaskPriorities().subscribe(result => {
      this.prioritySelect = result;
    });

    this.taskService.GeneralService({method: 'Estimates_Get_ProjectSalesCategory'}).subscribe(result=>{
      // console.log(result);
      this.salesCategorySelect = result;
    })
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'buttonsTask'
    });
  }

  prepareRowPart(info){
    if (info.rowType === "data") {
      if (info.data.MILESTONEID2 == 1) {
        info.rowElement.style.backgroundColor = "#e6c7a7";
      }
    }
  }

  mdMemorizeTask(){
    this.popupMemorizedTask=true;
    this.dataMemorizeTask.length==0 ? this.getMemorizeTasks() : '';
    this.dataSummaryMemorizeTask.length==0 ? this.getSummaryMemorize() : '';
  }

  //Summary Tasks
  getSummaryMemorize(){
    this.taskService.Get_ProjectTodoSummaryMemorized(this.projectid).subscribe(result=>{
      // console.log('Summary Memorize ', result);
      this.dataSummaryMemorizeTask = result;
    })
  }

  getMemorizeTasks(){
    this.taskService.Get_ProjectTodoMemorized(this.projectid).subscribe(result=>{
      // console.log('Memorize Task', result);
      this.dataMemorizeTask = result;
      // let categories = [];
      result.forEach(async (element, i) => {
        let obj = {method: 'Get_ProjectTodoMemorizedCategoriesByMemorizedID', mtaskid: element.ID}
        this.taskService.GeneralService(obj).subscribe(async (result)=>{
          // console.log('Results ',result);
          // categories.push(result);
          let category = [];
          let categoryId = [];
          result.map((x,j)=>{
            let found = this.salesCategorySelect.find(el=>el.ID==x.PCATID);
            // console.log('Encontrado ', found);
            if(found){
              category.push(found.PROJECTSLSCATEGORY);
              categoryId.push(found.ID);
            }
            if(result.length==j+1){
              // console.log('Category array ', category);
              this.dataMemorizeTask[i].categories = category.join(',');
              this.dataMemorizeTask[i].categoryIDs = categoryId.join(',');
            }
            
          })
          
        })
      });
      // console.log('Data + Categories ',this.dataMemorizeTask);
      
    })
  }

  //New Summary Memorize Task
  mdNewSummaryMemorizeTask(){
    this.popupNewSummaryMemorize = true;
    
    this.formSummaryMemorize = new FormGroup({
      name: new FormControl('', []),
      order: new FormControl('', []),
      id:  new FormControl(0, []),
    })
  }

  saveUpdateSummaryMemorize(){
    let form = this.formSummaryMemorize.value;
    // console.log(form);
    form.method = 'Insert_ProjectTodoSummaryMemorizedCE';
    this.taskService.Insert_ProjectTodoSummaryMemorizedCE(form).subscribe(result=>{
      // console.log(result);
      this.toast.success('The task has been updated successfully');
      this.popupNewSummaryMemorize = false;
      this.getSummaryMemorize();
    })
  }

  formatDuration(DURATION) {
    let durat = DURATION ? DURATION.toString().split('.') : ['', ''];
    durat[0] = durat[0] ? durat[0].substr(0, 2).padStart(2, '0') : '00';
    durat[1] = durat[1] ? durat[1].substr(0, 2).padEnd(2, '0') : '00';

    return durat[0] + ':' + durat[1];
  }

  editSummaryMemorize(data){
    // console.log(data);
    this.formSummaryMemorize = new FormGroup({
      name: new FormControl(data.NAME, []),
      order: new FormControl(data.SEQUENCE3, []),
      id:  new FormControl(data.ID, []),
    })
    this.popupNewSummaryMemorize = true;
  }

  //New Memorize Task
  mdNewMemorizeTask(){
    this.popupNewTaskMemorize = true;
    this.initNewMemorizeForm();
    
  }

  initNewMemorizeForm(){
    this.formTaskMemorize = new FormGroup({
      taskname: new FormControl('', []),
      taskresponsible: new FormControl('', []),
      taskpriotirty: new FormControl('', []),
      taskarea: new FormControl('', []),
      tasksort: new FormControl('', []),
      taskduration: new FormControl('', []),
      taskismstone: new FormControl('', []),
      taskcategoryid: new FormControl('', []),
      taskauotadd: new FormControl('', []),
      tasknumberofdays: new FormControl(null, []),
      tasksalescategory: new FormControl('', []),
      memorizedtaskid: new FormControl(0, []),
      memorizedsumamryid:  new FormControl('', []),
    })
    if(this.salesCategorySelect.length==0){
      this.taskService.GeneralService({method: 'Estimates_Get_ProjectSalesCategory'}).subscribe(result=>{
        // console.log(result);
        this.salesCategorySelect = result;
      })
    }
  }

  saveUpdateMemorizeTask(){
    let form = this.formTaskMemorize.value;
    form.taskismstone = form.taskismstone==true ? 1 : 0;
    form.taskauotadd = form.taskauotadd==true ? 1 : 0;
    form.method = 'Insert_Upadte_MemorizeTaskCE';
    if(this.categoriesMemorize){
      form.tasksalescategory = this.categoriesMemorize.join(',');
    }
    form.taskduration
    let duration = [];
    
      duration[0] = form.taskduration.substr(0, 2);
      duration[1] = form.taskduration.substr(2, 2);
      form.taskduration = duration[0]+'.'+duration[1];
    
    
    console.log(form);
    this.taskService.Insert_Upadte_MemorizeTaskCE(form).subscribe(result=>{
      // console.log(result);
      this.toast.success('The task has been updated successfully');
      this.popupNewTaskMemorize = false;
      this.getMemorizeTasks();
    })
  }

  editMemorize(data){
    // console.log(data);
    let reponsible = this.employeeSelect.find(el=>el.CONTACTNAME==data.ASSIGNEDSCTO);
    if(reponsible!==undefined){ reponsible = reponsible.ID}else{ reponsible = null }
    
    let category = this.categorySelect.find(el=>el.TODOCATEGORY== data.TODOCATEGORY);
    if(category!==undefined){ category= category.ID } else{ category = null};
    let priority = this.prioritySelect.find(el=>el.Description == data.PRIORITY);
    if(priority!==undefined){ priority = priority.ID } else { priority = null };
    let summary = this.dataSummaryMemorizeTask.find(el=>el.NAME == data.Expr1);
    if(summary!==undefined){summary = summary.ID }else{ summary = null };
    data.MILESTONEID2 = data.MILESTONEID2 == 0 ? false : true; 

    data.ESTIMATEDTIME = data.ESTIMATEDTIME ? data.ESTIMATEDTIME+'.00' : '00.00';
    let durat = data.ESTIMATEDTIME ? data.ESTIMATEDTIME.toString().split('.') : ['', ''];

    this.formTaskMemorize = new FormGroup({
      taskname: new FormControl(data.NAME, []),
      taskresponsible: new FormControl(reponsible, []),
      taskpriotirty: new FormControl(priority, []),
      taskarea: new FormControl(data.AREA, []),
      tasksort: new FormControl(data.SORT, []),
      taskduration: new FormControl(durat[0] + durat[1], []),
      taskismstone: new FormControl(data.MILESTONEID2, []),
      taskcategoryid: new FormControl(category, []),
      taskauotadd: new FormControl(data.AUTOADD, []),
      tasknumberofdays: new FormControl(data.DAYSFROMPSDATE, []),
      tasksalescategory: new FormControl(data.categoryIDs ? data.categoryIDs.split(',') : [], []),
      memorizedtaskid: new FormControl(data.ID, []),
      memorizedsumamryid:  new FormControl(summary, []),
    })
    // console.log(this.formTaskMemorize.value);
    this.categoriesMemorize = data.categoryIDs ? data.categoryIDs.split(',').map(x => +x) : [];
    // console.log(this.categoriesMemorize);
    this.popupNewTaskMemorize = true;
  }
}
